import { combineReducers } from "redux";
import fspConfigReducer from "./fspConfigReducer";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import providerInfoReducer from "./providerInfoReducer";
import errorReducer from "./errorReducer";
import institutionReducer from "./institutionReducer";
import selectionAccountsReducer from "./selectionAccountsReducer";
import sagasInProgress from "./sagasInProgressReducer";
import microServiceReducer from "./microServiceReducer";

export default combineReducers({
  fspConfig: fspConfigReducer,
  auth: authReducer,
  user: userReducer,
  providerInfo: providerInfoReducer,
  error: errorReducer,
  institution: institutionReducer,
  selectionAccounts: selectionAccountsReducer,
  sagasInProgress,
  microService: microServiceReducer,
});
